<template>
  <div
    :class="{'date-picker--alert':alert}"
    class="date-picker"
  >
    <div>
      <datepicker
        :language="fr"
        v-model="date"
        :class="{'-drop' : drop}"
        :input-class="inputClasses"
        :monday-first="true"
        :placeholder="placeholder"
        :disabled-dates="availability"
        :open-date="startDate"
        format="dd/MM/yyyy"
      />
      <i v-if="svg">
        <svg>
          <use :xlink:href="svg"></use>
        </svg>
      </i>
    </div>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { fr } from 'vuejs-datepicker/dist/locale'

export default {
  name: 'DatePicker',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    alert: {
      type: Boolean,
      default: false,
    },
    drop: {
      type: Boolean,
      default: false,
    },
    svg: {
      type: String,
      default: '',
    },
    availability: {
      type: Object,
      default: () => {},
    },
    startDate: {
      type: [Date, String],
      default: () => new Date(),
    },
    dateFromStore: {
      type: [Date, String],
      default: '',
    },

  },
  data() {
    return {
      fr,
      date: '',
      placeholder: 'jj/mm/aaaa',
      inputClasses: 'appearance-none date-picker',
    }
  },
  components: {
    Datepicker,
  },
  mounted() {
    this.toggleDisabled(this.disabled)
  },
  watch: {
    date(value) {
      this.$emit('date', value)
    },
    disabled(isDisabled) {
      this.toggleDisabled(isDisabled)
    },
    dateFromStore() {
      if (!this.dateFromStore) {
        this.date = '';
        return
      }
      this.date = this.dateFromStore
    },
  },
  methods: {
    toggleDisabled(isDisabled) {
      this.inputClasses = `appearance-none date-picker ${isDisabled ? 'inactive' : ''}`
    },
  },
}
</script>
<style scoped lang="scss">
@import '../../../../../_src/sass/config/vars';
@import '../../../../../_src/sass/config/mixins';
@import '../../../../../_src/sass/config/responsive';

.date-picker {
  @include shared-svg-inputs;

  div {
    width: 100%;
  }

  &--inactive {
    color: #878785;
    pointer-events: none;
  }

  &--alert {
    @include alert;
  }
}
</style>
